var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadTherapy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6203_9174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9829 1.01764C10.328 0.371825 9.44521 0.00976562 8.52543 0.00976562C7.60565 0.00976562 6.72284 0.371825 6.06793 1.01764L1.01793 6.06764C0.36616 6.71941 -6.86751e-09 7.6034 0 8.52514C6.86751e-09 9.44688 0.36616 10.3309 1.01793 10.9826C1.6697 11.6344 2.55369 12.0006 3.47543 12.0006C4.39717 12.0006 5.28116 11.6344 5.93293 10.9826L10.9829 5.93264C11.6287 5.27773 11.9908 4.39492 11.9908 3.47514C11.9908 2.55536 11.6287 1.67255 10.9829 1.01764ZM5.23293 10.2676C4.76721 10.724 4.14018 10.9782 3.48811 10.9749C2.83604 10.9716 2.21161 10.7111 1.75052 10.2501C1.28943 9.78896 1.02893 9.16453 1.02564 8.51246C1.02235 7.86039 1.27652 7.23336 1.73293 6.76764L3.90293 4.59514L7.40293 8.09514L5.23293 10.2676Z",
    fill: "#032279"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6203_9174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadTherapy);
export default __webpack_public_path__ + "static/media/badTherapy.4a04274b7506189f63b40e715f418fd0.svg";
export { ForwardRef as ReactComponent };